import LocalCache from '../backend/LocalCache'
import { IconName } from '../components/routing/RouteIcon'
import RoutingManager from '../components/routing/Routing'
import { IContract } from '../definitions/Contract'
import { ISystemConfig } from '../definitions/MiscSchema'
import Helper from '../helpers/Helper'
import { IInitial } from '../store/slices/AppSlice'

class SpotlightManagerClass {
    getActions = (): ISpotlightItem[] => {
        // cache contracts
        const cachedContracts: IContract[] = (LocalCache.get('contracts')?.value ?? []).filter(x => Helper.hasVal(x) && x?.status?.name?.toLocaleLowerCase() !== 'draft')
        const cachedContractTypes: ISystemConfig[] = LocalCache.get('filter-Contract Type')?.value ?? []
        const cachedLOB: ISystemConfig[] = LocalCache.get('filter-Line Of Business')?.value ?? []
        const cachedCounterparties: ISystemConfig[] = LocalCache.get('filter-Provider Groups')?.value ?? []
        const cachedContractStatus: ISystemConfig[] = LocalCache.get('filter-Contract Status')?.value ?? []
        const cachedProviders: ISystemConfig[] = LocalCache.get('filter-Providers')?.value ?? []

        return [
            ...RoutingManager.getLeftMenuRoutes()?.map(x => ({
                id: 'Routes ' + x.route,
                label: x.label,
                type: 'Routes',
                keywords: [x.label, x.route],
                params: { route: x.route },
                onClick: () => { },
                icon: x.route
            } as ISpotlightItem)) ?? [],
            ...cachedContracts?.map(x => ({
                id: 'Contracts ' + x?.uuid,
                label: x.name,
                type: 'Contracts',
                keywords: [x.name],
                params: { route: 'contract-details', params: { contract: x } },
                onClick: () => { },
                icon: 'contracts'
            }) as ISpotlightItem) ?? [],
            ...cachedContractTypes?.map(x => ({
                id: 'Contract Type ' + x.id,
                label: x.name,
                type: 'Contract Type',
                keywords: [x.name],
                params: { route: 'contracts', params: { contractTypeId: x.id } },
                onClick: () => { },
                icon: 'category'
            }) as ISpotlightItem) ?? [],
            ...cachedLOB?.map(x => ({
                id: 'Line Of Business ' + x.id,
                label: x.name,
                type: 'Line Of Business',
                keywords: [x.name],
                params: { route: 'contracts', params: { lineOfBusinessId: x.id } },
                onClick: () => { },
                icon: 'business'
            }) as ISpotlightItem) ?? [],
            ...cachedCounterparties?.map(x => ({
                id: 'Provider Groups ' + x.id,
                label: x.name,
                type: 'Provider Groups',
                keywords: [x.name],
                params: { route: 'contracts', params: { counterpartyId: x.id } },
                onClick: () => { },
                icon: 'provider-group'
            }) as ISpotlightItem) ?? [],
            ...cachedContractStatus?.map(x => ({
                id: 'Contract Status ' + x.id,
                label: x.name,
                type: 'Contract Status',
                keywords: [x.name],
                params: { route: 'contracts', params: { contractStatusId: x.id } },
                onClick: () => { },
                icon: 'thermometer'
            }) as ISpotlightItem) ?? [],
            ...cachedProviders?.map(x => ({
                id: 'Provider ' + x.id,
                label: x.name,
                type: 'Provider',
                keywords: [x.name],
                params: { route: 'provider-contracts', params: { providerId: x.id } },
                onClick: () => { },
                icon: 'provider'
            }) as ISpotlightItem) ?? []
        ]
    }

    historyToActions = (history: IInitial['spotlight']['history']): ISpotlightItem[] => {
        if (!history) return []
        const actions = this.getActions()

        return history.map(pastAction => {
            let item = actions.find(x => x.id === pastAction.id)

            if (!item && pastAction.id.startsWith(AI_SPOTLIGHT))
                item = { ...actions.find(k => k.id === AI_SPOTLIGHT), label: pastAction.params.query, id: pastAction.id }

            return item
        })
    }

    aiAction = () => this.getActions().find(x => x.id === AI_SPOTLIGHT)
}
const SpotlightManager = new SpotlightManagerClass()
export default SpotlightManager

export const AI_SPOTLIGHT = '@ai '

export interface ISpotlightItem {
    id: string
    label: string
    description?: string
    type: 'Routes' | 'Contracts' | 'Contract Type' | 'Line Of Business' | 'Contract Status' | 'Provider Groups' | 'Provider'
    keywords: string[]
    onClick?: () => void
    params?: any
    icon?: IconName
    exactMatchOnly?: boolean
}
